<template>
  <v-row class="mainContainer">
    <v-col class="sectionLeft" cols="12" sm="12" md="9"></v-col>

    <v-col class="sectionRight" cols="12" sm="12" md="3">
       <div class="contentWrapper">
        <div class="boxLogo">
          <img src="../../assets/logonova.png" alt="" />
        </div>
        <div class="title">
          <h3>
            <span class="sistrans">{{$t('system.system_abreviation')}}
              <span class="subtitle">{{$t('system.system_name')}}</span>
            </span><br>
            
          </h3>
        </div> 

        <ErrorLogin :resource="errorLogin" />

        <v-form
          @submit.prevent="login"
          v-model="valid"
          lazy-validation
          ref="form"
        >
          <v-text-field
            class="rounded-lg"
            label="CPF"
            placeholder="Digite seu CPF"
            outlined
            dense
            v-model="cpf"
            :rules="cpfRules"
            required
            color="#23720c"
            v-mask="'###.###.###-##'"
          ></v-text-field>

          <v-text-field
            class="rounded-lg"
            label="Senha"
            placeholder="Digite sua senha"
            outlined
            color="#23720c"
            dense
            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPass ? 'text' : 'password'"
            @click:append="showPass = !showPass"
            v-model="password"
            :rules="passRules"
            required
          ></v-text-field>

          <div class="captchaGrid" v-if="isTest === false">
            <section class="captcha__numbers">
              <canvas ref="numeroCanvas" width="122"  height="40"></canvas>
            </section>

            <div class="space"></div>

            <v-text-field
              class="rounded-lg"
              label="Captcha"
              placeholder="Digite o captcha"
              outlined
              dense
              color="#23720c"
              v-model="captcha"
              :rules="captchaRules"
              v-mask="'####'"
              required
            ></v-text-field>

            <div class="space"></div>

            <v-btn
              class="rounded-lg mb-5"
              color="#41916b"
              out
              elevation="0"
              height="40px"
              @click="setCaptcha()"
            >
              <v-icon dense color="white">mdi-refresh</v-icon>
            </v-btn>
          </div>

          <v-btn
            type="submit"
            class="rounded-lg mb-4"
            block
            color="#9ffbb3"
            elevation="1"
            large
            :loading="loading"
            :disabled="desativado"
            >
            {{$t('buttons.login')}} 
          </v-btn>
        </v-form>
        <ResetPass :resource="btnName" />  
      </div>
      <section class="layout__footer">
        <span>© Todos os Direitos Reservados - SESAB</span><br>
        <span class="font-bold">{{ version }}</span>
      </section>
    </v-col>

    <WaitingRoom v-if="showDialog" @closeSteps="showDialog = false" persistent/>
  </v-row>
</template>

<script>
import axios from "axios"; 
import packageJson from "@/../package.json"; 
import ErrorLogin from "../alerts/ErrorLogin-comp.vue";
import ResetPass from "./NewPassword-comp.vue";
import WaitingRoom from "./WaitingRoom-comp.vue";
import { mapActions } from "vuex/dist/vuex.common.js"; 
import LoginService from "@/service/auth/LoginService";
import Formatters from "@/utils/Formatters"; 
export default {
  data() {
    return {
      valid: true,
      showPass: false,
      cpf: "",
      captchaNumbers: [],
      captcha: "",

      cpfRules: [
        (v) => !!v || "O CPF é obrigatório",
        (v) => (v && v.length <= 14) || "Você excedeu o tamanho máximo.",
      ],
      password: "",
      passRules: [
        (v) => !!v || "A senha é obrigatória",
        (v) => (v && v.length <= 16) || "Você excedeu o tamanho máximo.",
      ],
      captchaRules: [
        (v) => !!v || "O captcha é obrigatório",
        (v) => (v && v.length <= 4) || "Você excedeu o tamanho máximo.",
      ], 
      img: "", 
      carregamento: false,
      desativado: false,
      errorLogin: [],
      btnName: "ESQUECI MINHA SENHA",
      showDialog: false,
      userData: {},
      loading: false
    };
  },
  
  components: {
    ErrorLogin,
    ResetPass,
    WaitingRoom
  },

  computed: {
    version() {
      return packageJson.version;
    },

    isTest(){
      return process.env.NODE_ENV === 'test'
    }

  },

  mounted(){
    this.setCaptcha();
  },


  methods: {

    ...mapActions([
      "changeCurrentUser"
    ]),

    setCaptcha() {
      const numbers = [];

      for (let index = 0; index < 4; index++) {
        const number = String(Math.floor(Math.random() * 9));

        numbers.push({
          number,
        });
      }

      const canvas = this.$refs.numeroCanvas;

      if (canvas) {
        const ctx = canvas.getContext("2d");
        if (ctx) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.font = "bold 28px Arial";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillStyle = "#207c51";

          const numero = `${numbers[0].number}${numbers[1].number}${numbers[2].number}${numbers[3].number}`;

          ctx.fillText(numero.toString(), canvas.width / 2, canvas.height / 2);
          this.captchaNumbers = numbers;
        } else {
          console.error("O contexto 2D não está disponível.");
        }
      }
    },

    checkCaptcha() {
      return this.captchaNumbers.map((v) => v.number).join("") === this.captcha
        ? true
        : false;
    },

    login() { 
      if (this.$refs.form.validate() && this.checkCaptcha() == true) {
        
        this.loading = true;
        const newCPF = Formatters.removeNonNumeric(this.cpf)
        const dados = new Object();
              dados.cpf = newCPF;
              dados.password = this.password;
              dados.captcha = this.captcha;
        
        axios
        .post(`${process.env.VUE_APP_URL}/validCredentials`, dados)
          .then((response) => {

            this.userData = response.data.user 
            if(response.data.user.linked_unit.length > 1 || response.data.user.linked_unit[0].profile_user_unities.length > 1){
              this.loading = false
              this.carregamento = true;
              this.desativado = true;

              let data = response.data.user
                  data.password = this.password

              this.changeCurrentUser(data); 

              setTimeout(() => {
                this.carregamento = false;
                this.desativado = false;
                this.cpf = "";
                this.password = "";
                this.captcha = "";
                this.$refs.form.resetValidation(); 


                if(response.data.user.linked_unit.length >= 1){
                  this.showDialog = true
                } 
              }, 1500);
            }else{ 
              this.loading = false
              this.continueInCurrentData()
            } 
          })
          .catch((error) => {
            this.loading = false

            this.errorLogin = error.response?.data.details || "Erro ao realizar login";
            this.captcha = "";
            this.setCaptcha();
          });
      } else {
            this.loading = false
            this.errorLogin = "Erro ao realizar login";
            this.captcha = "";
            this.setCaptcha();
      }
    },

    async continueInCurrentData(){ 
      let userData = {
          cpf: Formatters.removeNonNumeric(this.cpf),
          password: this.password,
          profile_id: this.userData.profile_id,
          unity_id: this.userData.unity_id ,
      }
      
      try {
        await LoginService.login(userData)
        
        setTimeout(() => {
          this.$router.push({ name: "Dashboard" });
        }, 1000);

      }catch(err) { 
        this.changeSnackbarData([
          true,
          "error",
          "Erro ao realizar login",
          err.response?.data?.details || err.error,
        ])
      }
    }
  },
};
</script>

<style scoped>
* {
  font-family: "Poppins";
}

.mainContainer {
  margin: 0;
  height: 100vh;
  background-color: #a8eca8;
  background-image: linear-gradient(0deg, #eaeeb0 0%, #52f18f 100%);
}


.sectionLeft {
  background: #ffffff;
  background-image: url(../../assets/background.png);
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
}

.sectionRight {
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* empurra o rodapé pro fim */
  padding: 35px;
  background: #fff;
  height: 100vh;
  box-sizing: border-box;
} 

.contentWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;  
  flex-grow: 1; 
} 

.sectionRight > .boxLogo {
  display: flex; 
  justify-content: center;
  align-items: center;
  width: 350px;   
  height: 150px;  
  margin-bottom: 10px;
}

.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 5px 0; 
}

.title h3 {
  margin: 0;
  line-height: 1.1; 
}

.title .sistrans {
  display: block;
  font-weight: 600; 
  font-size: 2.1rem; 
  color: #41916b;
  margin-bottom: 0; 
  text-align: center;
  padding: 0;
}

.title .subtitle {
  display: block;
  font-size: 1.1rem;
  font-weight: 400;
  color: #41916b;
  text-align: center; 
  margin-bottom: 2px; 
} 
 
.boxLogo > span {
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  font-size: 14px;
  line-height: 19px;
  color: #000;
}

.boxLogo img {
  width: 100%;
  height: auto;
  object-fit: contain;
  padding: 10px;
}

.captchaGrid {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;

}

.captchaGrid > .captcha__numbers {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 122px;
  height: 40px;
  background: #f3f3f3;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  max-height: 40px;
}

.captchaGrid > .space {
  width: 10px;

}

.layout__footer {
  text-align: center;
  padding-bottom: 10px;
  font-size: 0.9rem;
  color: #555;
}

/* Responsivo */
@media only screen and (max-width: 1380px) {
  .sectionLeft {
    flex: 0 0 70%;
    max-width: 70%;
  }

  .sectionRight {
    flex: 0 0 30%;
    max-width: 30%;
  }
}

@media only screen and (max-width: 960px) {
  .mainContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 40px;
  }
  .sectionLeft {
    display: none;
  }

  .sectionRight {
    min-width: 400px;
    border-radius: 20px;
    color: red;
  }
}
</style>
